import React, {useCallback, useState, useRef, useEffect} from "react";
import Prev from "../../assets/image/icon_prev.svg";
import TextInput from "../component/TextInput";
import NewDropdown from "../component/NewDropdown";
import {useHistory, useParams} from "react-router-dom";
import {useAsyncFn} from "react-use";
import {postAdicApplication, postAdicPlayList} from "@common/services/restapi/mypage";
import {Slide, toast, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {useAuth} from "@common/contexts/auth/AuthProvider";
import AdApplication from '@common/enums/AdApplication.enums'
import Page from "@common/enums/Page.enums";

const ApplicationTypes = [AdApplication.insertMedia, AdApplication.education, AdApplication.storeReference, AdApplication.etc];

function AdvertisementApplication() {
  const auth = useAuth();
  const { adicUser } = auth;

  const { playlistId } = useParams();
  const history = useHistory();

  const [useType, setUseType] = useState("")
  const [detailType, setDetailType] = useState("")
  const [company, setCompany] = useState("")
  const [department, setDepartment] = useState("")
  const [name, setName] = useState("")
  const [number, setNumber] = useState("")
  const [email, setEmail] = useState("")

  const handleDetailType = (e) => {
    setDetailType(e.target.value);
  }

  const handleCompany = (e) => {
    setCompany(e.target.value);
  }

  const handleDepartment = (e) => {
    setDepartment(e.target.value);
  }

  const handleName = (e) => {
    setName(e.target.value);
  }

  const handleNumber = (e) => {
    setNumber(e.target.value);
  }

  const handleEmail = (e) => {
    setEmail(e.target.value);
  }

  /*const handleChange = (e) => {
    const {name, value} = e.target;
    switch (name) {
      case detailType:
        setDetailType(value);
        break;
      case company:
        setCompany(value);
        break;
      case department:
        setDepartment(value);
        break;
      case name:
        setName(value);
        break;
      case number:
        setNumber(value);
        break;
      case email:
        setEmail(value);
        break;
    }
  }*/

  const handleGoBack = useCallback(() => {
    history.goBack();
  }, []);

  const handleSelectThing = useCallback((selectThing) => {
    setUseType(selectThing.status);
  },[]);

  const [postApplication, handlePostApplication] = useAsyncFn(async(reqBody) => {
    if (!postApplication.loading) {
      const result = await postAdicApplication(reqBody);
      // console.log("result  = ",result);
      if (result.hasOwnProperty("code") && result.code === "A200") {
        let failMsg = "입력되지 않은 정보가 존재합니다";
        if (result.code === 'not_found') {
          failMsg = "신청할 재생목록에 등록된 컨텐츠가 없습니다. 컨텐츠를 추가후 신청해주세요.";
        } else {
          failMsg = "제공 신청을 처리가 실패하였습니다.";
        }
        isFail(failMsg);
      } else {
        isSuccess();
        setTimeout(() => {
          history.goBack();
        }, 1000)
      }
    }

  }, []);

  const handleNewApplication = async () => {
    // 새 광고물 제공 신청 서버 등록
    const reqBody = {
      userId: adicUser.userId,
      playlistId: playlistId,
      useType: useType,
      useTypeDesc: detailType,
      company: company,
      department: department,
      name: name,
      phoneNumber: number,
      email: email,
    };

    await handlePostApplication(reqBody);
  };

  const isSuccess = () => toast.success("전송되었습니다", {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    closeButton: false
  });

  const isFail = (failMsg) => toast.error(failMsg, {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    closeButton: false
  });

  /*const clearUserInput = () => {
    setInputValue("");
  }*/

  return (
    <>
      <div className="common-header--top">
        <a className="prev-btn" onClick={handleGoBack}>
          <img src={Prev} alt=""/>
        </a>
        <h3 className="header-title">광고물 제공 신청</h3>
      </div>

      <div action="" className="application-form">
        <div className="text-input-wrap">
          <label className="text-input-label">사용용도</label>
          <NewDropdown
            additionalClassName="stats-select-list"
            thingsList={ApplicationTypes}
            onSelectThing={handleSelectThing}
          />
        </div>
        <TextInput
          value={detailType}
          inputClassName="detailType-input"
          hasLabel={true}
          labelText="상세용도"
          placeHolderText="상세용도를 입력하세요"
          hasErrorText={false}
          errorText="형식이 맞지 않습니다"
          hasRightIcon={false}
          onChange={handleDetailType}
        />
        <TextInput
          value={company}
          hasLabel={true}
          labelText="회사"
          placeHolderText="회사명을 입력하세요"
          hasErrorText={false}
          errorText="형식이 맞지 않습니다"
          hasRightIcon={false}
          onChange={handleCompany}
        />
        <TextInput
          value={department}
          hasLabel={true}
          labelText="부서"
          placeHolderText="부서명을 입력하세요"
          hasErrorText={false}
          errorText="형식이 맞지 않습니다"
          hasRightIcon={false}
          onChange={handleDepartment}
        />
        <TextInput
          value={name}
          hasLabel={true}
          labelText="이름"
          placeHolderText="이름을 입력하세요"
          hasErrorText={false}
          errorText="형식이 맞지 않습니다"
          hasRightIcon={false}
          onChange={handleName}
        />
        <TextInput
          value={number}
          hasLabel={true}
          labelText="연락처"
          placeHolderText="연락처를 입력하세요"
          hasErrorText={false}
          errorText="형식이 맞지 않습니다"
          hasRightIcon={false}
          onChange={handleNumber}
        />
        <TextInput
          value={email}
          hasLabel={true}
          labelText="이메일"
          placeHolderText="이메일을 입력하세요"
          hasErrorText={false}
          errorText="형식이 맞지 않습니다"
          hasRightIcon={false}
          onChange={handleEmail}
        />
        <button className="application-btn" onClick={handleNewApplication}>
          신청
        </button>
      </div>

      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Slide}
      />
    </>
  )
}

export default AdvertisementApplication;
